import { useAuthInfo } from '@/hooks/useAuthInfo';

export function useProApiAccess() {
  const { status, data } = useAuthInfo();

  if (status === 'success') {
    const createProApiKeys = Number(data.permissions.create_pro_api_keys);
    return {
      canCreateApiKeys: createProApiKeys === -1 || createProApiKeys > 0,
    };
  }

  return { canCreateApiKeys: false, status };
}
